export const TRANSITION = "all 0.2s ease";
export const GEO_POSITION_NOT_AVAILABLE_ERROR =
  "GEO_POSITION_NOT_AVAILABLE_ERROR";
export const HEADER_HIGHT_MOBILE = 56;
export const HEADER_HIGHT_DESKTOP = 80;
